import { deleteRequest, getRequest, postRequest, putRequest } from "../methods";

export const DeleteAPI = {
  accountSendOtp: async (body) =>
    await postRequest("/auth/delete-account-send-otp", body),
  verifyOtp: async (body) =>
    postRequest("/auth/delete-account-verify-otp", body),
  deleteAccountApi: async (body) => postRequest("/auth/delete-account", body),
};

export const PrivacyPolicyAPI = {
  getPrivacyPolicy: async (params) =>
    await getRequest("/privacy-policy", params),
};
